export default function Bonos() {
  const bonos = [
    {
      numero: '01',
      title: 'Lista de 50 Nichos Evergreen',
      description: 'Nichos probados y validados que generan ingresos consistentes año tras año. Demanda constante, baja competencia y alta rentabilidad.',
      valor: '197',
      borderColor: 'border-[#FF6B35]',
      accentColor: '#FF6B35',
      badge: 'EXCLUSIVO'
    },
    {
      numero: '02',
      title: 'Masterclass: De 0 a tus primeros S/ 1,000',
      description: 'Estrategia paso a paso para generar tus primeros mil soles con productos digitales. Sin experiencia previa necesaria.',
      valor: '247',
      borderColor: 'border-[#00D9FF]',
      accentColor: '#00D9FF',
      badge: 'ACCIÓN INMEDIATA'
    },
    {
      numero: '03',
      title: 'Actualizaciones Anuales al Motor de IA',
      description: 'Acceso durante todo el año a todas las mejoras, nuevas funcionalidades y actualizaciones del sistema de inteligencia artificial.',
      valor: '497',
      borderColor: 'border-[#FF6B35]',
      accentColor: '#FF6B35',
      badge: 'ANUAL'
    },
    {
      numero: '04',
      title: 'PDF: Guía de Productos Digitales que Más Venden',
      description: 'Documento exclusivo con los tipos de productos digitales con mayor demanda en Latinoamérica, estrategias de precio y canales de distribución recomendados.',
      valor: '97',
      borderColor: 'border-[#00D9FF]',
      accentColor: '#00D9FF',
      badge: 'SOLO HOY'
    },
    {
      numero: '05',
      title: 'Guía Avanzada: Creación de Imágenes con IA',
      description: 'La guía más completa y avanzada para crear imágenes profesionales con inteligencia artificial. Prompts, estilos, herramientas y técnicas para potenciar tus productos digitales con visuales de alto impacto.',
      valor: '197',
      borderColor: 'border-[#FF6B35]',
      accentColor: '#FF6B35',
      badge: 'NUEVO'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-32 bg-white relative overflow-hidden">
      {/* Subtle dot pattern */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'radial-gradient(circle, #999 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }}></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        {/* Header */}
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <div className="inline-block px-4 sm:px-5 py-1.5 sm:py-2 bg-[#0A0A0A] rounded-full mb-4 sm:mb-5">
            <span className="text-white text-xs sm:text-sm font-semibold uppercase tracking-wider">
              Valor Agregado
            </span>
          </div>

          <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-[#0A0A0A] mb-2 sm:mb-3 lg:mb-4 leading-tight px-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            Pack de Bonos Irresistibles
          </h2>
          <p className="text-sm sm:text-base lg:text-xl text-[#666] max-w-2xl mx-auto px-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Herramientas y recursos adicionales para acelerar tus resultados desde el día uno
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-5 lg:gap-6">
          {bonos.map((bono) => (
            <div
              key={bono.numero}
              className={`bg-white rounded-xl sm:rounded-2xl border-2 ${bono.borderColor} shadow-[0_8px_32px_rgba(0,0,0,0.08)] hover:shadow-[0_12px_40px_rgba(0,0,0,0.15)] transition-all duration-300 p-4 sm:p-5 lg:p-6 cursor-pointer group relative flex flex-col`}
            >
              {/* Badge Superior */}
              <div className="absolute -top-2 sm:-top-3 left-1/2 -translate-x-1/2 z-10">
                <div className="px-2.5 sm:px-3 py-0.5 sm:py-1 bg-[#FF6B00] rounded-full shadow-lg whitespace-nowrap">
                  <span className="text-white text-[10px] sm:text-xs font-bold uppercase tracking-wide" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    {bono.badge}
                  </span>
                </div>
              </div>

              {/* Number */}
              <div
                className="text-6xl sm:text-7xl lg:text-8xl font-black leading-none select-none mt-3 sm:mt-4 mb-1 sm:mb-2"
                style={{ fontFamily: 'Inter, sans-serif', color: bono.accentColor, opacity: 0.15 }}
              >
                {bono.numero}
              </div>

              {/* Content */}
              <div className="flex-1 flex flex-col">
                <h3 className="text-sm sm:text-base lg:text-lg font-bold text-[#0A0A0A] mb-1.5 sm:mb-2 leading-snug" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {bono.title}
                </h3>

                <p className="text-xs sm:text-sm text-[#666] leading-relaxed mb-3 sm:mb-4 flex-1" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {bono.description}
                </p>

                <div className="inline-block px-2.5 sm:px-3 py-1 sm:py-1.5 bg-[#00D9FF]/10 rounded-lg self-start">
                  <span className="text-[10px] sm:text-xs text-[#00D9FF] font-mono font-bold">
                    Valor: S/ {bono.valor}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Total Value Box */}
        <div className="text-center mt-8 sm:mt-12 lg:mt-16">
          <div className="inline-flex flex-col items-center gap-2 sm:gap-3 px-6 sm:px-8 lg:px-12 py-6 sm:py-8 bg-gradient-to-br from-[#FF6B00]/5 to-[#00D9FF]/5 border-2 border-[#FF6B00]/30 rounded-xl sm:rounded-2xl w-full sm:w-auto max-w-md sm:max-w-none mx-auto">
            <p className="text-sm sm:text-base text-[#666]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Valor Total de los Bonos:
            </p>
            <p className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#FF6B00]" style={{ fontFamily: 'Poppins, sans-serif' }}>
              S/ 1,235
            </p>
            <div className="w-full h-px bg-[#E0E0DE] my-0.5 sm:my-1"></div>
            <p className="text-xs sm:text-sm lg:text-base text-[#0A0A0A] font-semibold px-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
              <span className="text-[#00D9FF]">Incluidos GRATIS</span> con tu acceso a Nexus
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}